import { render, staticRenderFns } from "./TituloRelatorioValoresContratos.vue?vue&type=template&id=36696d7b&"
import script from "./TituloRelatorioValoresContratos.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioValoresContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports